import { h, Component } from 'preact';

export default class Contact extends Component {
  render() {
    return (
      <section class="contact">
        <h3><span class="fa fa-envelope">&nbsp;</span> Contact</h3>
        <p>Please call or text @ (719) 271-7670</p>
      </section>
    );
  }
}




// WEBPACK FOOTER //
// ./components/contact.js